import { TermsOfUseForManufacturerServicesSubPage } from '../TermsOfUseForManufacturerServicesSubPage';

export const ServiceSpecSheetPage = () => (
  <TermsOfUseForManufacturerServicesSubPage page="portal.termsOfUse.manufacturerServices.bikeSpecification" />
);
